import { SITE } from "@shared/site/site-config";

/** Her name across the ring: flat, wide-set capitals. Plain text, so it reads as a heading. */
export function OrlaWordmark() {
  return (
    <h1 className="orla-wordmark">
      <span className="orla-wordmark__word" aria-hidden="true">
        {SITE.name.toUpperCase()}
      </span>
      <span className="visually-hidden">
        {SITE.name}. {SITE.tagline}
      </span>
    </h1>
  );
}
